import { Component } from '@angular/core';
import 'devextreme/integration/jquery';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'logiApp';
}
